import { CoinIcon } from './icons';

export interface RewardPillProps {
  /** Bucks amount; rendered as `+150`. Ignored when `mystery` is set. */
  amount?: number;
  /** Gold `?` instead of a number — the mystery is the amount, not the currency. */
  mystery?: boolean;
  /** Free text instead of an amount (e.g. localized `~30s` while processing). */
  text?: string;
  /** Left-to-right shimmer for processing states (brief §5). */
  shimmer?: boolean;
  /** Accessible name, e.g. t('ec2.a11y.bucksReward', {amount}). */
  label: string;
  className?: string;
}

/**
 * Gold reward pill (brief §6): 12px radius chip, --bucks at 15% alpha background,
 * coin glyph + tabular amount in Buck Gold. Gold appears ⇒ it's CloudBucks.
 */
export function RewardPill({ amount, mystery, text, shimmer, label, className = '' }: RewardPillProps) {
  const content = mystery ? '?' : (text ?? (amount !== undefined ? `+${amount}` : ''));
  return (
    <span
      role="img"
      aria-label={label}
      data-testid="ec-reward-pill"
      className={
        `inline-flex items-center gap-1.5 rounded-(--radius-chip) bg-bucks/15 px-2.5 py-1 ` +
        `font-display text-sm font-[650] text-bucks tabular-nums ` +
        `${shimmer ? 'ec-shimmer ' : ''}${className}`
      }
    >
      <CoinIcon size={14} aria-hidden />
      <span aria-hidden>{content}</span>
    </span>
  );
}
